import { Injectable, Injector, ViewChild } from '@angular/core';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { wrapAllMethodsWithLogging } from 'src/app/core/decorators/log-all-errors.decorator';
import { LoggingService } from './logging.service';
declare var google: any;

@Injectable({
  providedIn: 'root'
})
export class GpsService {
  address: string;
  city: string;
  state: string;
  fulladdress: string;
  zipcode: string;
  latLng: any;
  NoAdressMessage: any;
  componentName: string = 'gpsService';

  constructor(private _geolocation: Geolocation, public platform: Platform, public _translateService: TranslateService,
    private injector: Injector
  ) {
    wrapAllMethodsWithLogging(this, this.componentName, this.injector, LoggingService);
    this.NoAdressMessage = this._translateService.instant('common_text.no_address_text');
  }

  async checkCurrentPosition() {
    var options = {
      enableHighAccuracy: false,
      timeout: 30000,
      maximumAge: 100000,
      timezone: true
    };
    return await this._geolocation.getCurrentPosition(options);
  }

  // async decodeGeoLocation(lat, long) {
  //   let geocoder = new google.maps.Geocoder();
  //   this.latLng = new google.maps.LatLng(lat, long);
  //   let request = {
  //     latLng: this.latLng
  //   };
  //   return await geocoder.geocode(request, (results, status) => {
  //     if (status == google.maps.GeocoderStatus.OK) {
  //       if (results[0] != null) {
  //         setTimeout(() => {
  //           this.address = results[0].formatted_address;  //<<<=== DOES NOT WORK, when I output this {{ address }} in the html, it's empty
  //         }, 2000)
  //       } else {
  //         this.address = this.NoAdressMessage;
  //       }
  //     }
  //   })
  // }
}
